import { groupFiles } from "./groupFiles";
import { groupSections } from "./groupSections";

export const parseFields = fields => groupSections(groupFiles(fields));
